import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../Store/store';

interface TermsFooterProps {
  onTermsClick?: () => void;
}

/**
 * Terms & Copyright Footer Component
 * 
 * Displays Terms of Service link and copyright information.
 * Can be used on landing page and game postgame screens.
 */
const TermsFooter: React.FC<TermsFooterProps> = ({ onTermsClick }) => {
    const { currentGame } = useSelector((state: RootState) => state.gameSession);
    const textColor = currentGame?.colorSecondary || 'rgba(255, 255, 255, 0.5)';

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.5rem',
            width: '100%',
            marginTop: '0.5rem'
        }}>
            {/* Terms & Privacy link */}
            {onTermsClick && (
                <button
                    onClick={onTermsClick}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: textColor,
                        opacity: 0.5,
                        fontSize: '0.9rem',
                        cursor: 'pointer',
                        padding: '10px',
                        textDecoration: 'underline',
                        fontFamily: 'Open Sans',
                        transition: 'opacity 0.2s ease',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                    onMouseLeave={(e) => e.currentTarget.style.opacity = '0.5'}
                >
                    Terms of Service & Privacy Policy
                </button>
            )}
            
            {/* Copyright */}
            <p style={{
                fontSize: '0.85rem',
                color: textColor,
                opacity: 0.5,
                fontFamily: 'Open Sans',
                margin: '0.5rem 0',
                textAlign: 'center'
            }}>
                © {new Date().getFullYear()} Mental Mint LLC. All rights reserved.
            </p>
        </div>
    );
};

export default TermsFooter;
